export default __webpack_public_path__ + "static/media/nutri.5f5d12de.svg";